<template>
  <div class="block pb-6">
    <breadcrumb-list>
      <breadcrumb-link view="Home" label="Home" />
      <breadcrumb-link view="Alerting" label="Alerting" :active="true" />
    </breadcrumb-list>

    <div class="container">
      <div class="box">

        <!-- Header -->
        <div class="level">
          <div class="level-left">
            <h1 class="title mb-0">Alerts</h1>
          </div>

          <div class="level-right">
            <b-button type="is-primary" @click="goToCreateAlert">
              Create Alert
            </b-button>
          </div>
        </div>

        <!-- Subtitle under the line -->
        <p class="subtitle is-6 has-text-grey mt-2">
          Create custom alerts that automatically appear on inquiries when selected criteria are met.
        </p>

      </div>
    </div>

    <!-- Alerts Table -->
    <div class="container mt-4">
      <div class="box">
        <div class="p-4 shadow-sm rounded-lg">

          <b-table :data="alerts" :loading="loading" :detailed="true" :show-detail-icon="true" detail-key="id" striped
            hoverable paginated per-page="10">

            <!-- Provider Name -->
            <b-table-column field="provider_name" label="Provider" v-slot="props" width="200px">
              {{ props.row.alert_provider?.name || '' }}
            </b-table-column>

            <!-- Prefix -->
            <b-table-column field="prefix" label="Prefix" v-slot="props" width="200px">
              {{ props.row.alert_prefix?.prefix || '' }}
            </b-table-column>

            <!-- Payer Name -->
            <b-table-column field="payer_name" label="Payer" v-slot="props" width="200px">
              {{ props.row.alert_payer?.name || '' }}
            </b-table-column>

            <!-- Group -->
            <b-table-column field="group_number" label="Group" v-slot="props" width="200px">
              {{ props.row.alert_group_number?.group_number || '' }}
            </b-table-column>

            <b-table-column field="group_name" label="Group Name" v-slot="props" width="200px">
              {{ props.row.alert_group_name?.group_name || '' }}
            </b-table-column>

            <!-- Plan Name -->
            <b-table-column field="plan_name" label="Plan Name" v-slot="props" width="200px">
              {{ props.row.alert_plan_name?.plan_name || '' }}
            </b-table-column>

            <!-- Plan Number -->
            <b-table-column field="plan_number" label="Plan Number" v-slot="props" width="200px">
              {{ props.row.alert_plan_number?.plan_number || '' }}
            </b-table-column>

            <!-- Insurance Type -->
            <b-table-column field="insurance_type" label="Insurance Type" v-slot="props" width="200px">
              {{ props.row.alert_insurance_type?.name || '' }}
            </b-table-column>

            <!-- created by -->
            <b-table-column field="user" label="User" v-slot="props" width="200px">
              {{ props.row.user?.first_name + ' ' + props.row.user?.last_name || '' }}
            </b-table-column>

            <!-- Created At -->
            <b-table-column label="Created At" v-slot="props" width="200px">
              <div class="created-at">
                <div>{{ formatDate(props.row.created_at).date }}</div>
                <div class="has-text-grey is-size-7">
                  {{ formatDate(props.row.created_at).time }}
                </div>
              </div>
            </b-table-column>

            <!-- Color -->
            <b-table-column field="color" label="Color" width="80px" v-slot="props">
              <div class="has-text-centered">
                <span class="tag" :style="{ backgroundColor: props.row.color }"></span>
              </div>
            </b-table-column>

            <!-- Actions -->
            <b-table-column label="Actions" width="120px" v-slot="props">
              <b-button type="is-danger" size="is-small" @click="confirmDelete(props.row)">
                Delete
              </b-button>
            </b-table-column>

            <!-- Detail Row -->
            <template #detail="props">
              <p>
                <strong>Message:</strong> {{ props.row.message || '' }}<br>
              </p>
            </template>

            <!-- Empty State -->
            <template #empty>
              <section class="section has-text-centered">
                <b-icon icon="file-alert" size="is-large"></b-icon>
                <p class="mt-2">No alerts found</p>
              </section>
            </template>

          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../request';

export default {
  name: 'Alerting',

  data() {
    return {
      loading: false,
      alerts: [],
      showAlertPopup: false,
      selectedAlert: null,
      dropdowns: {
        payerNames: [],
        groupNumbers: [],
        planNames: [],
        planNumbers: [],
        insuranceTypes: [],
        facilities: []
      },
    };
  },

  created() {
    this.fetchAlerts();
  },

  methods: {
    async fetchAlerts() {
      try {
        this.loading = true;
        const response = await request.get('/alerts');
        this.alerts = response.data.alerts || [];
      } catch (err) {
        this.$buefy.toast.open({ message: 'Failed to load alerts', type: 'is-danger' });
      } finally {
        this.loading = false;
      }
    },

    confirmDelete(alert) {
      this.$buefy.dialog.confirm({
        title: 'Delete Alert',
        message: `Are you sure you want to delete this alert "${alert.message}"? This action cannot be undone.`,
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteAlert(alert.id),
      });
    },

    formatDate(dateString) {
      if (!dateString) return { date: '', time: '' };
      const d = new Date(dateString);
      return {
        date: d.toLocaleDateString(),
        time: d.toLocaleTimeString()
      };
    },

    async deleteAlert(id) {
      try {
        await request.delete(`/alerts/${id}`);
        this.$buefy.toast.open({ message: 'Alert deleted', type: 'is-success' });
        this.fetchAlerts();
      } catch {
        this.$buefy.toast.open({ message: 'Failed to delete alert', type: 'is-danger' });
      }
    },

    goToCreateAlert() {
      this.$router.push({ name: 'AlertCreate' });
    },
  }
};
</script>

<style>

.created-at {
  white-space: normal;
}

</style>